module.exports = __webpack_public_path__ + "static/media/card6.e677b115.jpg";